<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #f2f6fc">
    <Title :title="{ name: '发票开具申请', path: '/item/invoice' }"></Title>
    <el-card class="box-card" style="min-height: 650px; margin-top: 15px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="left"
        label-width="150px"
      >
        <el-divider content-position="left">发票信息</el-divider>
        <el-form-item label="所属项目" prop="projectId">
          <el-select
            style="width: 50%"
            v-model="ruleForm.projectId"
            placeholder="请选择所属项目"
            filterable
            @change="getProjectInfo"
          >
            <el-option
              v-for="item in projectList"
              :key="item.projectId"
              :label="item.projectName"
              :disabled="item.projectState === 6"
              :value="item.projectId"
            >
              <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>&nbsp&nbsp
              <el-tag v-if="item.projectState === 6" type="info" size="mini">S: 已终止</el-tag>
              <span style="float: left">&nbsp&nbspM: {{ item.managerName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目合同" prop="contractId">
          <el-select
            style="width: 50%"
            v-model="ruleForm.contractId"
            placeholder="请选择所属合同"
            filterable
            clearable
          >
            <el-option
              v-for="item in contractList"
              :key="item.contractId"
              :label="item.contractName"
              :value="item.contractId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票时间">
          <el-date-picker
              v-model="ruleForm.invoiceTime"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择开票时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发票金额" prop="invoiceAmount">
          <el-input v-model="ruleForm.invoiceAmount" maxlength="12">
            <template slot="append">{{ getDigitUppercase }}</template>
          </el-input>
        </el-form-item>
        <el-form-item label="发票类型" prop="invoiceType" required>
          <el-radio-group v-model="ruleForm.invoiceType">
            <el-radio :label="1">电子普票</el-radio>
            <el-radio :label="2">纸质普票</el-radio>
            <el-radio :label="3">电子专票</el-radio>
            <el-radio :label="4">纸质专票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="单位名称" prop="invoiceCompany">
          <el-input v-model="ruleForm.invoiceCompany" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="taxCode">
          <el-input v-model="ruleForm.taxCode" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="地址及电话" prop="contact">
          <el-input v-model="ruleForm.contact" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="开户行及账号" prop="bankInfo">
          <el-input v-model="ruleForm.bankInfo" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="发票备注" prop="remarks">
          <el-input type="textarea" rows=5 maxlength="300" v-model="ruleForm.remarks" ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="submitShow" type="primary" @click="submitForm">提交申请</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Title from "../../Title";
import {digitUppercase, isNum} from "../../../util";
import {requestInvoice,requestAllProject,requestApplyDetail,requestProjectDetail} from "@/api";

export default {
  components: { Title },

  data() {
    const validatePrice = (rule, value, callback) => {
      if (!value) {
        callback(new Error("金额不能为空"));
      } else if (!isNum(value)) {
        callback(new Error("请输入正确格式的金额"));
      } else if (value.split(".").length > 2) {
        callback(new Error("请输入正确格式的金额")); //防止输入多个小数点
      } else if (value.indexOf(".") > -1 && value.substring(value.indexOf(".") + 1).length > 2) {
        callback(new Error("最大保留两位小数"));
      } else if (value.length > 12) {
        callback(new Error("长度最大12个字符"))
      } else {
        this.ruleForm.projectAmountExpect = value
        callback();
      }
    }
    return {
      submitShow: true,
      projectList: [],
      contractList: [],
      ruleForm: {
        projectId: "",
        contractId: "",
        invoiceTime: "",
        invoiceAmount: "",
        invoiceType: 1,
        invoiceCompany: "",
        taxCode: "",
        contact: "",
        bankInfo: "",
        remarks: "",
      },
      rules: {
        projectId: [
          { required: true, message: "请选择所属项目", trigger: "blur" },
        ],
        contractId: [
          { required: true, message: "请选择所属合同", trigger: "blur" },
        ],
        invoiceAmount: [
          { required: true, validator: validatePrice, trigger: 'blur' },
        ],
        invoiceCompany: [
          { required: true, message: "单位名称不能为空", trigger: "blur" },
        ],
        taxCode: [
          { required: true, message: "税号不能为空", trigger: "blur" },
        ],
        contact: [],
        bankInfo: []
      },
    };
  },

  computed: {
    getDigitUppercase() {
      return digitUppercase(this.ruleForm.invoiceAmount)
    },
  },

  mounted() {

  },

  created() {
    this.$watch('ruleForm.invoiceType', (n, o) => {
      if (n > 2) {
        this.rules.contact.push({ required: true, message: "联系方式不能为空", trigger: "blur" })
        this.rules.bankInfo.push({ required: true, message: "银行信息不能为空", trigger: "blur" })
      } else {
        this.rules.contact = []
        this.rules.bankInfo = []
        if (this.$refs['ruleForm']) {
          this.$refs['ruleForm'].clearValidate(['contact','bankInfo'])
        }
      }
    }, { immediate: true });

    this.applyId = this.$route.query.applyId
    this.applyServiceId = this.$route.query.applyServiceId
    this.applyType = this.$route.query.applyType
    if (this.applyId || this.applyServiceId || this.applyType) {
      this.reapply = true
      this.getObject()
    }
    this.getAllProject()
  },
  methods: {
    getAllProject() {
      requestAllProject({}).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.projectList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getProjectInfo(projectId) {
      this.ruleForm.contractId = ""
      requestProjectDetail({projectId: projectId,}).then(res => {
        if (res.code === 200) {
          this.contractList = res.object.contracts
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    submitForm() {
      this.submitShow = false
      this.$refs['ruleForm'].validate(async (isPass) => {
        if (isPass) {
          let param = this.ruleForm
          // 重新申请需要的参数
          if (this.reapply) {
            param.applyId = this.applyId
          }
          console.log("提交的参数:",param)
          const res = await requestInvoice(param)
          if (res.code === 200) {
            this.$message.success(res.msg)
            if (this.reapply) {
                this.$router.push({query: {}})
                this.reapply = false
              }
            this.$refs['ruleForm'].resetFields()
          } else {
            this.$message.error(res.msg)
          }
        }
        this.submitShow = true
      })
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.getProjectInfo(res.object.detail.projectId)
            this.ruleForm = res.object.detail
            this.ruleForm.invoiceAmount = this.ruleForm.invoiceAmount.toString()
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
  }
};
</script>
